import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** 12h display in POS Hub weekly hours UI; API still uses 24h with seconds. */
export const POSHUB_TIME_DISPLAY_FORMAT = 'hh:mm A';

const PARSE_FORMATS = ['HH:mm:ss', 'HH:mm', 'hh:mm A', 'h:mm A'];

export function parsePosHubTimeString(str) {
  if (!str || typeof str !== 'string') return null;
  for (let i = 0; i < PARSE_FORMATS.length; i += 1) {
    const d = dayjs(str, PARSE_FORMATS[i], true);
    if (d.isValid()) return d;
  }
  return null;
}

export function formatPosHubTimeForApi(dayjsVal) {
  return dayjsVal ? dayjsVal.format('HH:mm:ss') : '';
}
